import React from 'react';
import { RiArrowUpSFill, RiArrowDownSFill } from 'react-icons/ri';

const SortableHeader = ({ label, field, sortConfig, requestSort }) => {
    const isActive = sortConfig.key === field;
    const isAsc = isActive && sortConfig.direction === 'asc';
    const isDesc = isActive && sortConfig.direction === 'desc';

    const handleSort = (direction) => {
        requestSort(field, direction);
    };

    return (
        <div className="inline-flex items-center gap-1 select-none">
            <span>{label}</span>
            <div className="inline-flex flex-col items-center leading-none">
                <span>
                <RiArrowUpSFill
                    size="22px"
                    className={isAsc ? 'text-black cursor-pointer' : 'text-whiteDark cursor-pointer'}
                    style={{ marginBottom: '-2px' }}
                    onClick={(e) => { e.stopPropagation(); handleSort('asc'); }}
                />
                </span>
                <span className={`-mt-2`}>
                <RiArrowDownSFill
                    size="22px"
                    className={isDesc ? 'text-black cursor-pointer' : 'text-whiteDark cursor-pointer'}
                    style={{ marginTop: '-2px' }}
                    onClick={(e) => { e.stopPropagation(); handleSort('desc'); }}
                />
                </span>
            </div>
        </div>
    );
};

export default SortableHeader;
